/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, November 9th 2021, 12:43:24 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { ReadOnlyModel, WritableModel, AuditableModel } from "lib/schemas/abstract";
import { schemaBuilder, Many2OneUUIDPKBaseSchema } from "lib/validation";
import { Organization } from "./organizations/Organization";

export interface Sector extends ReadOnlyModel<true> {
  name: string;
  description: string;
  isic_code: string;
}

export interface Country extends ReadOnlyModel<false> {
  countrycode: string;
  countryname: string;
  iso2: string;
  countryprefix: string;
}

export interface Currency extends ReadOnlyModel<true> {
  code: string;
  countries: string[];
  name: string;
  numeric: string;
}

export interface ContentTag extends WritableModel<true>, AuditableModel {
  name: string;
  description?: string;
  slug: string;
  organization: Organization["id"];
  image?: string;
}

export const ContentTagValidationSchema: schemaBuilder.SchemaOf<
  Omit<ContentTag, "created_at" | "updated_at" | "created_by" | "updated_by" | "image">
> = schemaBuilder.object().shape({
  id: schemaBuilder.string().uuid().optional().nullable(),
  name: schemaBuilder.string().required("Tag Name is required"),
  slug: schemaBuilder.string().required("Tag Slug is required"),
  description: schemaBuilder.string().optional().nullable(),
  organization: Many2OneUUIDPKBaseSchema().required("Organization Id is required."),
});

export type TLocales = Record<string, string>;

export type TranslatableModel = {
  id: string;
  name: string;
};

export type TranslatableContent = {
  source_text_id: string;
  record_id: string | number;
  model: string;
  model_name: string;
  field_name: string;
  source_language: string;
  source_text: string;
  i18n: Record<string, string>;
};
